import { ProjectListItem } from '../ProjectListItem/ProjectListItem.js';
import { type Projects_userProfile$key } from '@/__generated__/relay/Projects_userProfile.graphql.js';
import { Layout } from '@/components/Layout/Layout.js';
import { MobileProjects } from '@/components/MobileProjects/MobileProjects.js';
import { FadeUpInView } from '@/components/Motion/Fade/FadeUpInView/FadeUpInView.js';
import { ProjectsFragment } from '@/documents/fragments/Projects.js';
import { useIPFragment } from '@/hooks/useIPFragment.js';
import { useMatchMedia } from '@/hooks/useMatchMedia.js';
import { minWidthMediaQueries } from '@/stitches/media.js';
import { getUserProjectNodes } from '@/utilities/getUserProjectNodes.js';

export const ProjectsList = ({
  queryRef,
}: {
  readonly queryRef: Projects_userProfile$key;
}) => {
  const isMediumViewport = useMatchMedia(minWidthMediaQueries.bp2);
  const { portfolioProjects } = useIPFragment<Projects_userProfile$key>(
    ProjectsFragment,
    queryRef,
  );

  const projects = getUserProjectNodes(portfolioProjects);

  if (!projects.length) return null;

  return isMediumViewport ? (
    <Layout.Section
      css={{
        '@bp0': { padding: '$28 0 $64' },
        '@bp2': { padding: '$64 0 $88' },
        '@bp3': { padding: '$120 0 0' },
      }}
      id="projects"
    >
      <Layout.Grid>
        <Layout.GridColumn initial={12}>
          <Layout.FlexColumn
            css={{ '@bp0': { gap: '$72' }, '@bp3': { gap: '$120' } }}
          >
            {projects.map((node, index) => {
              return (
                <FadeUpInView key={`project-${node.id}`}>
                  <ProjectListItem
                    index={index}
                    node={node}
                  />
                </FadeUpInView>
              );
            })}
          </Layout.FlexColumn>
        </Layout.GridColumn>
      </Layout.Grid>
    </Layout.Section>
  ) : (
    <MobileProjects
      projects={projects}
      uppercaseTrigger={false}
      variant="text"
    />
  );
};
